module.exports = __webpack_public_path__ + "media/images/pages/about_us/team_members/carine-8f295c067d4bd798adb4cdf05139bf6b.png";